import React, { useEffect, useCallback, useState } from 'react';
import AppLayout from '../../component/appLayout';
import { useDispatch, useSelector } from 'react-redux';
import { getAllRecurringTasks } from '../../services/taskServices';
import TasksDataV2 from '../../component/tasks/taskDataV2';
import { captureException } from '../../services/logService';
import { isEmpty } from '../../helpers/common';
import { RootReducerInterface } from '../../interfaces/RootReducerInterface';
import { rootStore } from '../../mobx/rootStore';
import { MobxMyTaskModelInterface } from '../../interfaces/TaskInterface';
import { observer } from 'mobx-react-lite';

const RecurringTask: React.FC = () => {
  // States
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState<MobxMyTaskModelInterface[]>([]);
  //use selector state variables
  const { taskStore } = rootStore;
  const { recurringTasks } = taskStore;
  const workspaceSelector = useSelector((state: RootReducerInterface) => state.workspace);
  const { workspace } = workspaceSelector;

  // Other variables
  const dispatch = useDispatch();
  const loadData = useCallback(async () => {
    try {
      if (!isEmpty(workspace?.id)) {
        setLoading(true);
        await dispatch(getAllRecurringTasks());
      }
    } catch (e) {
      captureException(e);
      console.log('error', e);
    } finally {
      setLoading(false);
    }
  }, [dispatch, workspace?.id]);

  useEffect(() => {
    loadData();
  }, [loadData]);

  useEffect(() => {
    if (recurringTasks && Array.isArray(recurringTasks)) {
      const groupedTasks = recurringTasks.reduce((acc: MobxMyTaskModelInterface[], task) => {
        let group = acc.find((g) => g.project_id === task.projectId);
        if (!group) {
          group = {
            project_id: task.projectId,
            title: task?.project?.name || '',
            tasks: []
          };
          acc.push(group);
        }
        group.tasks.push(task);
        return acc;
      }, []);
      setData(groupedTasks);
    } else {
      setData([]);
    }
  }, [recurringTasks]);

  return (
    <AppLayout>
      <TasksDataV2 data={data} loading={loading} isMyTask={true} loadData={loadData} isRecurringTask={true} />
    </AppLayout>
  );
};

export default observer(RecurringTask);
